module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/thumbs/3-dbfd7118a2f3d0cf1e09a985bfefacfd.webp";